const header = "_275h1ot4j9d";
const heading = "_275h1ubza6j";

export { header, heading };
import "./shared.header.style.linaria.module.css";
//# sourceMappingURL=shared.header.style.js.map
